export default "__VITE_ASSET__238227e9__"